import axios from "axios";
import { Parser } from "html-to-react";
import React, { useContext, useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import { FaDatabase, FaDesktop, FaGithub } from "react-icons/fa";
import { useParams } from "react-router-dom";
import { Context } from "../../context";
import classes from "./Demo.module.css";
import DemoBreadcrumb from "./DemoBreadcrumb";
import DemoDetailsGallery from "./DemoDetailsGallery";
import DemoDetailsOther from "./DemoDetailsOther";
const url = "https://demo-api.davidebalice.dev/api/demo/";

const DemoDetails = () => {
  const [arrayTech, setArrayTech] = useState([]);
  const [demoData, setDemoData] = useState([]);
  const [isVisible, setIsVisible] = useState(false);
  const { debug, lang } = useContext(Context);

  const formatText = (input) => {
    const lines = input.split("\n");
    return lines.map((line, index) => (
      <>
        {line}
        <br />
      </>
    ));
  };

  const changeVisibility = (isVisibleSensor) => {
    if (isVisibleSensor && isVisible === false) {
      setIsVisible(true);
    }
  };
  const [filteredData, setFilteredData] = useState([]);
  const { slug } = useParams();
  let delay = 0;

  const getData = async () => {
    try {
      const response = await axios.get(url + slug);
      console.log(response.data.demo);

      setDemoData(response.data.demo);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <>
      <Container
        fluid
        className={`${classes.demoDetailBg} text-center pb-5 pt-5`}
      >
        <Container
          fluid
          className={`${classes.demoDetailContainer} text-center pb-5 pt-5`}
        >
          <DemoBreadcrumb title={demoData.title} />
          <div className="row">
            <div className="col-md-6">
              <div
                className={classes.demoCardDetail}
                style={{
                  background: `url("https://demo-api.davidebalice.dev/api/demo/cover/${demoData.imageCover}")`,
                }}
              >
                <div className={classes.demoTech}>
                  {arrayTech.map((val, index) => (
                    <div>
                      <img
                        key={filteredData.id}
                        className={classes.demoTechImg}
                        src={"/assets/images/demos/" + val + "_icon.jpg"}
                        alt="demo"
                      />
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className={`${classes.detailCol} col-md-6 text-left`}>
              <h1 className={`${classes.demoTitle} text-8 mb-4 fw-600`}>
                {demoData.title}
              </h1>

              {demoData.frontend && (
                <>
                  <div className="demo-data-details mb-2">
                    <div className="portfolio-overlay-details">
                      <a
                        href={demoData.frontend}
                        target="_blank"
                        rel="noreferrer"
                        className="btn-demo-link"
                      >
                        <span className="btn btn-outline-light btn-sm btn-demo-details btn-demo-frontend">
                          <FaDesktop className={`btn-demo-icon`} />
                          <span>frontend</span>
                        </span>
                      </a>
                    </div>

                    <div>
                      <a
                        href={demoData.frontend}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {demoData.frontend}
                      </a>
                    </div>
                  </div>
                </>
              )}

              {demoData.backend && (
                <>
                  <div className="demo-data-details mb-2">
                    <div className="portfolio-overlay-details">
                      <a
                        href={demoData.backend}
                        target="_blank"
                        rel="noreferrer"
                        className="btn-demo-link"
                      >
                        <span className="btn btn-outline-light btn-sm btn-demo-details btn-demo-backend">
                          <FaDatabase className={`btn-demo-icon`} />
                          <span>backend</span>
                        </span>
                      </a>
                    </div>

                    <div>
                      <a
                        href={demoData.backend}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {demoData.backend}
                      </a>
                    </div>
                  </div>
                </>
              )}

              {demoData.github && (
                <>
                  <div className="demo-data-details mb-2">
                    <div className="portfolio-overlay-details">
                      <a
                        href={demoData.github}
                        target="_blank"
                        rel="noreferrer"
                        className="btn-demo-link"
                      >
                        <span className="btn btn-outline-light btn-sm btn-demo-details btn-demo-github">
                          <FaGithub className={`btn-demo-icon`} />
                          <span>github frontend</span>
                        </span>
                      </a>
                    </div>

                    <div>
                      <a
                        href={demoData.github}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {demoData.github}
                      </a>
                    </div>
                  </div>
                </>
              )}

              {demoData.githubBackend && (
                <>
                  <div className="demo-data-details mb-2">
                    <div className="portfolio-overlay-details">
                      <a
                        href={demoData.githubBackend}
                        target="_blank"
                        rel="noreferrer"
                        className="btn-demo-link"
                      >
                        <span className="btn btn-outline-light btn-sm btn-demo-details btn-demo-github">
                          <FaGithub className={`btn-demo-icon`} />
                          <span>github backend</span>
                        </span>
                      </a>
                    </div>

                    <div>
                      <a
                        href={demoData.githubBackend}
                        target="_blank"
                        rel="noreferrer"
                      >
                        {demoData.githubBackend}
                      </a>
                    </div>
                  </div>
                </>
              )}

              <p
                className="mt-5 "
                style={{
                  whiteSpace: "pre-line",
                }}
              >
                {Parser().parse(demoData.description)}
              </p>
            </div>
          </div>
        </Container>
      </Container>

      <DemoDetailsGallery
        showText
        type="frontend"
        data={demoData.gallery_frontend}
        caption={demoData.caption_frontend}
      />

      <DemoDetailsGallery
        type="backend"
        data={demoData.gallery_backend}
        caption={demoData.caption_backend}
      />

      <div className={classes.demoLinea}></div>
      <DemoDetailsOther id={demoData.id} />
      <script src="/vendor/jquery/jquery.min.js"></script>
      <script src="/vendor/bootstrap/js/bootstrap.bundle.min.js"></script>
      <script src="/js/theme.js"></script>
    </>
  );
};

export default DemoDetails;
